// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1xEqK","title":"Info_title__2aUlF","links":"Info_links__1vw1d","link":"Info_link__3XVjy","logo":"Info_logo__22l5k"};